export const joblist = [
{
    id: "1",
    company: "Impact Group Marketing",
    start: "March 2024",
    end: "",
    title: "Web Developer",
    description: "",
},
{
    id: "2",
    company: "Codesulting, LLC.",
    start: "April 2019",
    end: "January 2024",
    title: "Front End Developer",
    description: "",
}

 ]